/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from "react";
import { Space, Button, Input, message, Modal, Upload, UploadFile, Select, TimePicker, Switch, Spin } from "antd";
import { PlusOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { useFetchProperty, useAddProperty, useDeleteProperty, useUpdateStatusProperty } from "../services/hotelandairbnb.service";
import { useFetchSlider, useAddSlider, useFetchAccommodationType, useUpdateStatusSlider } from "../services/sectionslider.service";
import { useFetchCountry } from "../services/countries.service";
import { useFetchCities } from "../services/cities.service";
import { Col, Drawer, Form, Row, Image, Card } from 'antd';
import IResponse from '../types/response';
import { ICountry } from "../types/countries";
import { useNavigate } from "react-router-dom";
import { compareObjects, getLabel, isNotNullUndefined, isNotNullUndefinedBlank } from "../helpers/common";
import { storage } from "../utils/storage";
import { eventEmitter } from "../helpers/eventemitter";
import { azureBlobStorageConfig } from '../helpers/config';
import { BlobServiceClient } from '@azure/storage-blob';
import { IEditHotelAndAirbnb, IHotelAndAirbnb, IAccommodationTypes } from "../types/hotelandairbnb";
import { IEditSectionSlider, ISectionSlider } from "../types/sectionslider";
import dayjs, { Dayjs } from 'dayjs';
import ReactQuill from 'react-quill';
import ImagePreviewGroup from "./imagepreviewgroup";
import { useGetSasToken } from '../services/blobcontext.service';
import { useAuth } from "../context/AuthContext";
const HotelAndAirbnb: React.FC = () => {
    const { Search } = Input;
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [slider, setSlider] = useState<any[]>([]);
    const [property, setProperty] = useState<IHotelAndAirbnb[]>([]);
    const [viewProperty, setViewProperty] = useState<IHotelAndAirbnb>();
    const [accommodationTypes, setAccommodationTypes] = useState<IAccommodationTypes[]>([]);
    const [country, setCountry] = useState<ICountry[]>([]);
    const [form] = Form.useForm();
    const [sliderForm] = Form.useForm();
    const [editingSlider, setEditingSlider] = useState<IEditSectionSlider | null>(null);
    const [editingProperty, setEditingProperty] = useState<IEditHotelAndAirbnb | null>(null);
    const isPropertyEdited = useRef<boolean>(false);
    const isSliderEdited = useRef<boolean>(false);
    const [sliderModalType, setSliderModalType] = useState<'update' | 'add' | ''>('');
    const [propertyModalType, setPropertyModalType] = useState<'delete' | 'update' | 'add' | ''>('');
    const [isConfirmPropertyModalVisible, setIsConfirmPropertyModalVisible] = useState(false);
    const [isViewPropertyModalVisible, setIsViewPropertyModalVisible] = useState(false);
    const [isConfirmSliderModalVisible, setIsConfirmSliderModalVisible] = useState(false);
    const [propertyId, setPropertyId] = useState<any>('');
    const [formUpdateValues, setFormUpdateValues] = useState<any>({});
    const [propertyFormUpdateValues, setPropertyFormUpdateValues] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSliderLoading, setIsSliderLoading] = useState(false);
    const formInitialValues = useRef<any>({});
    const formUpdatedValues = useRef<any>({});
    const searchValue = useRef<string>("");
    const [isSliderModalOpen, setIsSliderModalOpen] = useState(false);
    const [galleryImages, setGalleryImages] = useState<UploadFile[]>([]);
    const [propertyGalleryImages, setPropertyGalleryImages] = useState<UploadFile[]>([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [featuredImage, setFeaturedImage] = useState<UploadFile[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [mapUrl, setMapUrl] = useState("");
    const [checkInValue, setCheckInValue] = useState<any>('');
    const [checkOutValue, setcheckOutValue] = useState<any>('');
    const [propertyIds, setPropertyIds] = useState<string[]>([]);
    const [placeDescription, setPlaceDescription] = useState("");
    const [sasToken, setSasToken] = useState<string | null>(null);
    const [isSasLoaded, SetIsSasLoaded] = useState<boolean>(false);
    const editor_ref = useRef<ReactQuill>(null);
    const { hasPermission, permissionsLoaded, loadPermissions } = useAuth();

    useEffect(() => {
            loadPermissions();
    }, [permissionsLoaded]);

    const HotelandairbnbCreate = hasPermission("HOTEL_AIRBNB", "CREATE");
    const HotelandairbnbEdit = hasPermission("HOTEL_AIRBNB", "UPDATE");
    const HotelandairbnbDelete = hasPermission("HOTEL_AIRBNB", "DELETE");

    const checkIfSliderEdited = (slider: ISectionSlider | null): boolean => {
        if (!slider) return false;
        return slider?.title !== '';
    };

    const checkIfPropertyEdited = (property: IEditHotelAndAirbnb | null): boolean => {
        if (!property) return false;
        return property.key !== 0 || property.propertyTitle !== '' || property.cityName !== '';
    };

    useEffect(() => {
        isPropertyEdited.current = (checkIfPropertyEdited(editingProperty));
    }, [editingProperty]);

    useEffect(() => {
        isSliderEdited.current = (checkIfSliderEdited(editingSlider));
    }, [editingSlider]);

    useEffect(() => {
        let userRoleId = parseInt(storage.getUserRoleId() ?? "0");
        if (![1, 4].includes(userRoleId)) {
            navigate("/");
        }
        else {
            getSasToken();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isSasLoaded) {
            getCountryList("", "", "");
            getSliderList("Hotel And Airbnb");
            getPropertyList("");
            getAccommodationTypeList();
            getCitiesList("", "", "", "", "", "")
        }
    }, [isSasLoaded]);

    const getSasToken = () => {
        getSasTokenMutation.mutate({});
    }

    const getSasTokenMutation = useGetSasToken({
        onSuccess: (response: IResponse) => {
            if (response?.data != null) {
                setSasToken(response.data);
                SetIsSasLoaded(true);
                message.success(response.statusMessage);
                return;
            }

            message.error(response.statusMessage);
            SetIsSasLoaded(true);

        },
        onError: (error) => {
            message.error(error.message);
            SetIsSasLoaded(true);
        }
    });

    const getCountryList = async (searchValue: string, isServiceableAttendant: any, isServiceableTraveler: any) => {
        getCountryMutation.mutate({ searchFilter: searchValue, isServiceableAttendant: isServiceableAttendant, isServiceableTraveler: isServiceableTraveler });
    };

    const modules = {
        toolbar: [
            [{ 'font': [] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'header': '1' }, { 'header': '2' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'align': [] }],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean']
        ],
    };

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
        'list', 'bullet', 'indent',
        'link', 'image', 'video',
        'color', 'background',
        'script', 'align', 'direction'
    ];

    const getCountryMutation = useFetchCountry({
        onSuccess: (response: IResponse) => {
            if (response != null && response !== undefined) {
                response.data = response;
                setCountry(response.data);
            } else {
                message.error("Unexpected response format of Country list:", response);
            }
        },
        onError: (error) => {
            message.error("Unexpected response format of Country list:", error.message);
        },
    });

    const getCitiesList = async (stateId: string, countryId: string, search: string, isFavourite: any, isServiceableAttendant: any, isServiceableTraveler: any) => {
        setIsLoading(true);
        getCitiesMutation.mutate({
            stateId: stateId,
            countryId: countryId,
            searchFilter: search,
            isFavourite: isFavourite,
            isServiceableAttendant: isServiceableAttendant,
            isServiceableTraveler: isServiceableTraveler
        });
    };

    const getCitiesMutation = useFetchCities({
        onSuccess: (response: any) => {
            if (isNotNullUndefined(response)) {
                setCities(response.data);
                setIsLoading(false);
            }
        }, onError: (error) => {
            message.error(error.message);
            setIsLoading(false);
        }
    });

    const getSliderList = async (sliderCategoryType: string) => {
        setIsSliderLoading(true);
        getSliderMutation.mutate({
            sliderCategoryType: sliderCategoryType
        });
    };

    const getSliderMutation = useFetchSlider({
        onSuccess: (response: any) => {
            if (response != null && response !== undefined) {
                const result = response;
                const formattedData = result.map((data: any) => {
                    let galleryImageUrl = data.galleryImageUrl
                    if (galleryImageUrl) {
                        try {
                            const parsedImageGallery = JSON.parse(galleryImageUrl);

                            const updatedGalleryImages = parsedImageGallery.map((img: any) => ({
                                ...img,
                                FeaturedImageUrl: `${img.FeaturedImageUrl}?${sasToken}`,
                            }))
                            galleryImageUrl = JSON.stringify(updatedGalleryImages);
                        }
                        catch (error) {
                            console.error("Invalid galleryImageUrl JSON", error);
                        }
                    }
                    return {
                        ...data,
                        galleryImageUrl
                    }
                })
                setSlider(formattedData);
                setIsSliderLoading(false);
            } else {
                message.error("Unexpected response format: " + response);
                setIsSliderLoading(false);
            }
        },
        onError: (error) => {
            message.error(error.message);
            setIsSliderLoading(false);
        },
    });

    const getAccommodationTypeList = async () => {
        getAccommodationTypeMutation.mutate({});
    };

    const getAccommodationTypeMutation = useFetchAccommodationType({
        onSuccess: (response: any) => {
            if (response != null && response !== undefined) {
                setIsLoading(false);
                setAccommodationTypes(response);
            } else {
                message.error("Unexpected response format:", response);
                setIsLoading(false);
            }
        },
        onError: (error) => {
            message.error(error.message);
            setIsLoading(false);
        },
    });

    const getPropertyList = async (searchFilter: string) => {
        setIsLoading(true);
        getPropertyMutation.mutate({ searchFilter: searchFilter });
    };

    const getPropertyMutation = useFetchProperty({
        onSuccess: (response: any) => {
            if (response != null && response !== undefined) {
                const formattedData = response.map((data: any) => {
                    const featuredImageUrl = data.featuredImageUrl
                        ? `${data.featuredImageUrl}?${sasToken}`
                        : null;

                    let galleryImageUrl = data.galleryImageUrl;
                    try {
                        const parsedGallery = JSON.parse(galleryImageUrl);
                        const updatedGallery = parsedGallery.map((img: any) => ({
                            ...img,
                            ImageUrl: `${img.ImageUrl}?${sasToken}`,
                        }));
                        galleryImageUrl = JSON.stringify(updatedGallery);
                    } catch (e) {
                        console.error("Invalid galleryImageUrl JSON", e);
                    }

                    return {
                        ...data,
                        featuredImageUrl,
                        galleryImageUrl,
                    };
                });
                setProperty(formattedData);
                setIsLoading(false);
            } else {
                message.error("Unexpected response format:", response);
                setIsLoading(false);
            }
        },
        onError: (error) => {
            message.error(error.message);
            setIsLoading(false);
        },
    });

    const showDrawer = () => {
        eventEmitter.emit("clickableChange", true);
        if (isPropertyEdited) {
            isPropertyEdited.current = false;
        }
        sliderForm.resetFields();
        setOpen(true);
    };

    const onClose = () => {
        eventEmitter.emit("clickableChange", false);
        sliderForm.resetFields();
        form.resetFields();
        setGalleryImages([]);
        setPropertyGalleryImages([]);
        setFeaturedImage([]);
        setMapUrl("");
        setIsSliderModalOpen(false);
        setOpen(false);
    };


    const addProperty = useAddProperty({
        onSuccess: () => {
            getPropertyList("");
            getSliderList("Hotel And Airbnb");
            setPropertyGalleryImages([]);
            setFeaturedImage([]);
            setMapUrl("");
            setIsLoading(false);
            form.resetFields();
            setOpen(false);
            if (propertyModalType === 'update') {
                message.success("Property has been updated successfully!");
            }
            else {
                message.success("Property has been Added successfully!");
            }
            eventEmitter.emit("clickableChange", false);
        },
        onError: (error) => {
            setIsLoading(false);
            message.error(error.message);
        },
    });

    const addSlider = useAddSlider({
        onSuccess: (response: IResponse) => {
            if (response !== null && response.statusCode === 200) {
                message.success(response.statusMessage);
                setIsSliderLoading(false);
                sliderForm.resetFields();
                getSliderList("Hotel And Airbnb");
            }
            else {
                setIsSliderLoading(false);
                message.warning(response.statusMessage);
            }
            onClose();
            setIsSliderLoading(false);
            sliderForm.resetFields();
        },
        onError: (error) => {
            setIsSliderLoading(false);
            message.error(error.message);
        },
    });

    const deleteProperty = useDeleteProperty({
        onSuccess: () => {
            message.success("Property has been deleted successfully!");
            getCountryList("", "", "");
            getPropertyList("");
            getSliderList("Hotel And Airbnb");
        },
        onError: (error: any) => {
            if (isNotNullUndefined(error.response) && isNotNullUndefined(error.response.data) && isNotNullUndefinedBlank(error.response.data.message)) {
                message.error(error.response.data.message);
            } else {
                message.error("An unexpected error occurred.");
            }
        },
    });

    const updateStatusProperty = useUpdateStatusProperty({
        onSuccess: () => {
            message.success("Property status has been updated successfully!");
            getPropertyList("");
        },
        onError: (error: any) => {
            if (isNotNullUndefined(error.response) && isNotNullUndefined(error.response.data) && isNotNullUndefinedBlank(error.response.data.message)) {
                message.error(error.response.data.message);
            } else {
                message.error("An unexpected error occurred.");
            }
        }
    });

    const updateStatusSlider = useUpdateStatusSlider({
        onSuccess: () => {
            message.success("Slider status has been updated successfully!");
            getSliderList("Hotel And Airbnb");
        },
        onError: (error: any) => {
            if (isNotNullUndefined(error.response) && isNotNullUndefined(error.response.data) && isNotNullUndefinedBlank(error.response.data.message)) {
                message.error(error.response.data.message);
            } else {
                message.error("An unexpected error occurred.");
            }
        }
    });

    const onDeleteProperty = (record: any) => {
        setPropertyModalType('delete');
        setIsConfirmPropertyModalVisible(true);
        setPropertyFormUpdateValues({ propertyTitle: record.propertyTitle });
        setPropertyId(record.propertyPlaceID);
    }

    const handlePropertySave = async () => {
        try {
            if (propertyModalType === 'delete') {
                deleteProperty.mutate(propertyId);

            }
            else if (propertyModalType === 'update' && setEditingProperty) {
                setIsLoading(true);
                addProperty.mutate({ ...setEditingProperty, ...propertyFormUpdateValues });
            }
            else if (propertyModalType === 'add') {
                setIsLoading(true);
                addProperty.mutate(propertyFormUpdateValues);
            }
            setIsConfirmPropertyModalVisible(false);

        } catch (error) {
            message.error('Failed to save');
        }
    };

    const handleSliderSave = async () => {
        try {
            if (sliderModalType === 'update' || sliderModalType === 'add') {
                setIsSliderLoading(true);
                addSlider.mutate({
                    sliderID: formUpdateValues.sliderID,
                    title: formUpdateValues.title,
                    propertyPlaceID: formUpdateValues.propertyPlaceID,
                    sliderCategoryTypeID: formUpdateValues.formUpdateValues ?? 1,
                    isActive: formUpdateValues.isActive ?? 1
                });
            }
            setIsConfirmSliderModalVisible(false);
            setIsSliderModalOpen(false);
            sliderForm.resetFields();
        } catch (error) {
            message.error('Failed to save');
            setIsSliderLoading(false);
        }
    };

    const getModalTitle = () => {
        let message = "";
        if (propertyModalType === 'delete') {
            message = "Confirm Deletion!";
        } else if (propertyModalType === 'update') {
            message = "Confirm Update!";
        }
        else if (propertyModalType === 'add') {
            message = "Confirm Add!";
        }
        return message;
    };

    const getPropertyViewModalTitle = () => {
        let message = <p>{viewProperty?.propertyTitle}</p>;
        return message;
    };

    const getSliderModalTitle = () => {
        let message = "";
        if (sliderModalType === 'update') {
            message = "Confirm Update!";
        }
        else if (sliderModalType === 'add') {
            message = "Confirm Add!";
        }
        return message;
    };

    const getSliderModelContent = () => {
        let modalContent = <></>;
        if (sliderModalType === 'update') {
            modalContent = (
                <p>Are you sure you want to update the <b>{formUpdateValues.title}</b> slider? Once updated, this slider can be edited and it's details will be updated accordingly. Do you wish to proceed?</p>
            );
        }
        else if (sliderModalType === 'add') {
            modalContent = (
                <p>Are you sure you want to add the <b>{formUpdateValues.title}</b> slider? Once added, this slider can be edited and it's details will be updated accordingly. Do you wish to proceed?</p>
            );
        }
        return modalContent;
    };

    const getPropertyModelContent = () => {
        let modalContent = <></>;
        if (propertyModalType === 'delete') {
            modalContent = (
                <p>Are you sure you want to delete <b>{propertyFormUpdateValues.propertyTitle}</b> Property's Delete request? Once deleted, this property will not be recovered. Do you wish to proceed?</p>
            );
        } else if (propertyModalType === 'update') {
            modalContent = (
                <p>Are you sure you want to update <b>{propertyFormUpdateValues.propertyTitle}</b> Property's Update request? Once updated, this property can be edited and their details will be updated accordingly. Do you wish to proceed?</p>
            );
        }
        else if (propertyModalType === 'add') {
            modalContent = (
                <p>Are you sure you want to add <b>{propertyFormUpdateValues.propertyTitle}</b> Property's Add request? Once added, this property can be edited and their details will be updated accordingly. Do you wish to proceed?</p>
            );
        }
        return modalContent;
    };

    const getViewPropertyModelContent = () => {
        let modalContent = <></>;

        modalContent = (
            <div>

                <div className="overflow-x-auto whitespace-nowrap m-2">
                    {viewProperty?.galleryImageUrl && JSON.parse(viewProperty.galleryImageUrl).length > 0 ? (
                        JSON.parse(viewProperty.galleryImageUrl).map((img: any, idx: number) => (
                            <img
                                key={idx}
                                src={img.ImageUrl}
                                alt={`Gallery ${idx}`}
                                className="inline-block w-32 h-24 rounded object-cover mr-2 mb-1"
                            />
                        ))
                    ) : (
                        <div className="text-gray-500">No gallery images found</div>
                    )}
                </div>
                <p><strong>Country</strong>: <span>{viewProperty?.countryName}</span></p>
                <p><strong>City</strong>: <span>{viewProperty?.cityName}</span></p>
                <p><strong>Description</strong>: <span>{viewProperty?.bathrooms} Bedrooms {viewProperty?.bathrooms} Bathrooms {viewProperty?.beds} Sleeps</span></p>
                <p><strong>Contact</strong>: <span>{viewProperty?.contactInfo}</span></p>
                <p><strong>Amenities</strong>: <span>{viewProperty?.amenities}</span></p>
                <p><strong>Rules</strong>: <span>{viewProperty?.houseRules}</span></p>
                <a target="_blank" href={viewProperty?.cTA_Link} className="btn" style={{
                    display: 'inline-block',
                    padding: '10px 20px',
                    background: '#0F1B84',
                    color: 'white',
                    marginTop: '15px',
                    borderRadius: '6px',
                    textDecoration: 'none'
                }}
                >
                    {viewProperty?.cTA_Label}
                </a>
            </div>
        );
        return modalContent;
    };

    const handlePropertyModalCancel = () => {
        setIsLoading(false);
        setIsConfirmPropertyModalVisible(false);
    };

    const handleViewPropertyModalCancel = () => {
        setIsLoading(false);
        setIsViewPropertyModalVisible(false);
    };

    const handleConfirmSliderModalCancel = () => {
        setIsSliderLoading(false);
        setIsConfirmSliderModalVisible(false);
    };

    const handleViewProperty = (value: IHotelAndAirbnb) => {
        setIsViewPropertyModalVisible(true);
        setViewProperty(value);
    }

    const onFinish = (values: IHotelAndAirbnb) => {
        setPropertyModalType(((isPropertyEdited.current) ? 'update' : 'add'));
        const param = {
            propertyPlaceID: values.propertyPlaceID,
            countryID: values.countryID, propertyTitle: values.propertyTitle,
            featuredImageUrl: featuredImage.length > 0 ? featuredImage[0].url : "", cityID: values.cityID,
            description: placeDescription, bedrooms: values.bedrooms, bathrooms: values.bathrooms,
            beds: values.beds, guestCapacity: values.guestCapacity,
            amenities: values.amenities, checkInTime: checkInValue,
            checkOutTime: checkOutValue, mapLocations: values.mapLocations,
            contactInfo: values.contactInfo, houseRules: values.houseRules, cTA_Label: values.cTA_Label,
            cTA_Link: values.cTA_Link, accommodationTypeID: values.accommodationTypeID,
            galleryImageUrl: propertyGalleryImages.length > 0 ? propertyGalleryImages.map(x => x.url) : []
        };
        if (propertyModalType === 'update') {
            formInitialValues.current = {
                countryID: values.countryID, propertyTitle: values.propertyTitle,
                featuredImageUrl: featuredImage.length > 0 ? featuredImage[0].url : "", cityID: values.cityID,
                description: placeDescription, bedrooms: values.bedrooms, bathrooms: values.bathrooms,
                beds: values.beds, guestCapacity: values.guestCapacity,
                amenities: values.amenities, checkInTime: checkInValue,
                checkOutTime: checkOutValue, mapLocations: values.mapLocations,
                contactInfo: values.contactInfo, houseRules: values.houseRules, cTA_Label: values.cTA_Label,
                cTA_Link: values.cTA_Link, accommodationTypeID: values.accommodationTypeID,
                galleryImageUrl: propertyGalleryImages.length > 0 ? propertyGalleryImages.map(x => x.url) : []
            }
            formUpdatedValues.current = {
                countryID: values.countryID, propertyTitle: values.propertyTitle,
                featuredImageUrl: featuredImage.length > 0 ? featuredImage[0].url : "", cityID: values.cityID,
                description: placeDescription, bedrooms: values.bedrooms, bathrooms: values.bathrooms,
                beds: values.beds, guestCapacity: values.guestCapacity,
                amenities: values.amenities, checkInTime: checkInValue,
                checkOutTime: checkOutValue, mapLocations: values.mapLocations,
                contactInfo: values.contactInfo, houseRules: values.houseRules, cTA_Label: values.cTA_Label,
                cTA_Link: values.cTA_Link, accommodationTypeID: values.accommodationTypeID,
                galleryImageUrl: propertyGalleryImages.length > 0 ? propertyGalleryImages.map(x => x.url) : []
            }
            setPropertyFormUpdateValues(formUpdatedValues);

        }
        setIsConfirmPropertyModalVisible(true);
        setPropertyFormUpdateValues(param);
    };

    const onSliderFinish = (values: any) => {
        setSliderModalType(((isSliderEdited.current) ? 'update' : 'add'));
        const param = {
            sliderID: values.sliderID,
            title: values.title,
            propertyPlaceID: propertyIds
        };
        if (sliderModalType === 'update') {
            formInitialValues.current = { sliderID: values.sliderID, title: values.title, propertyPlaceID: propertyIds, sliderCategoryTypeID: values.sliderCategoryTypeID }
            formUpdatedValues.current = { title: editingSlider?.title, propertyPlaceID: propertyIds, sliderCategoryTypeID: values.sliderCategoryTypeID }
            if (compareObjects(formInitialValues.current, formUpdatedValues.current)) {
                onClose();
                setIsConfirmSliderModalVisible(false);
                return;
            }
        }
        setIsConfirmSliderModalVisible(true);
        setFormUpdateValues(param);
    };

    const onEditSliderClick = (record: IEditSectionSlider) => {
        setEditingSlider(record);
        isSliderEdited.current = true;

        let parsedGalleryImages: any[] = [];
        try {
            parsedGalleryImages = JSON.parse(record.galleryImageUrl || "[]");
        } catch (e) {
            message.error("Invalid galleryImageUrl JSON:");
        }

        const selectedPropertyIds = [
            ...new Set(
                parsedGalleryImages.map((img) => img.PropertyPlaceID.toLowerCase())
            )
        ];

        const galleryImageFiles: UploadFile[] = parsedGalleryImages.map((img, index) => ({
            uid: `${index}`,
            name: img.PropertyTitle || `Gallery Image ${index + 1}`,
            status: "done",
            url: img.FeaturedImageUrl
        }));

        setGalleryImages(galleryImageFiles);

        if (!property || property.length === 0) {
            const retry = setInterval(() => {
                if (property && property.length > 0) {
                    clearInterval(retry);
                    setFormFields(record, selectedPropertyIds, galleryImageFiles);
                }
            }, 100);
        } else {
            setFormFields(record, selectedPropertyIds, galleryImageFiles);
        }
        setPropertyIds(selectedPropertyIds);
    };

    const setFormFields = (
        record: IEditSectionSlider,
        selectedPropertyIds: string[],
        galleryImageFiles: UploadFile[]
    ) => {
        sliderForm.setFieldsValue({
            sliderID: record.sliderID,
            title: record.title,
            propertyPlaceID: selectedPropertyIds,
        });

        formInitialValues.current = {
            sliderID: record.sliderID,
            title: record.title,
            galleryImageUrl: galleryImageFiles.map((x) => x.url),
            propertyPlaceID: selectedPropertyIds,
        };
        setIsSliderModalOpen(true);
    };

    const onEditPropertyClick = (record: any) => {
        setPlaceDescription(record.description);
        isPropertyEdited.current = true;
        setEditingProperty(record);
        const checkInTime = dayjs(record.checkInTime, 'HH:mm:ss');
        const checkOutTime = dayjs(record.checkOutTime, 'HH:mm:ss');

        setCheckInValue(checkInTime.format('HH:mm:ss'));
        setcheckOutValue(checkOutTime.format('HH:mm:ss'));
        const embedUrl = getEmbedUrl(record.mapLocations);
        setMapUrl(embedUrl);
        const matchedAccommodation = accommodationTypes?.find(x => x.accommodationTypeName === record.accommodationTypeName)
        const matchedCountry = country.find(x => x.countryName === record.countryName)
        if (matchedCountry?.countryId) {
            const cntID = matchedCountry?.countryId.toString();
            getCitiesList("", cntID, "", "", "", "");
        }
        // const matchedCity = cities.find(x => x.cityName === record.cityName)

        form.setFieldsValue({
            propertyPlaceID: record.propertyPlaceID,
            countryID: matchedCountry?.countryId, propertyTitle: record.propertyTitle,
            featuredImageUrl: record.featuredImageUrl, cityID: record.cityID,
            description: record.description, bedrooms: record.bedrooms, bathrooms: record.bathrooms,
            beds: record.beds, guestCapacity: record.guestCapacity,
            amenities: record.amenities, checkInTime: checkInTime,
            checkOutTime: checkOutTime, mapLocations: record.mapLocations,
            contactInfo: record.contactInfo, houseRules: record.houseRules, cTA_Label: record.cTA_Label,
            cTA_Link: record.cTA_Link, accommodationTypeID: matchedAccommodation?.accommodationTypeID,
            galleryImageUrl: propertyGalleryImages.length > 0 ? propertyGalleryImages.map(x => x.url) : []
        });

        if (record.featuredImageUrl) {
            const featuredFile: UploadFile = {
                uid: '-1',
                name: 'Featured Image',
                status: 'done',
                url: record.featuredImageUrl,
            }
            setFeaturedImage([featuredFile]);
        }
        const parsedGalleryImages: { ImageUrl: string }[] = [];

        try {
            parsedGalleryImages.push(...JSON.parse(record.galleryImageUrl || '[]'));
        } catch (e) {
            message.error("Failed to parse galleryImageUrl");
        }

        const galleryImageFiles: UploadFile[] = parsedGalleryImages.map((img, index) => ({
            uid: `${index}`,
            name: `Gallery Image ${index + 1}`,
            status: 'done',
            url: img.ImageUrl,
        }));
        setPropertyGalleryImages(galleryImageFiles);

        formInitialValues.current = {
            propertyPlaceID: record.propertyPlaceID,
            countryID: record.countryID, propertyTitle: record.propertyTitle,
            featuredImageUrl: record.featuredImageUrl, cityID: record.cityID,
            description: record.description, bedrooms: record.bedrooms, bathrooms: record.bathrooms,
            beds: record.beds, guestCapacity: record.guestCapacity,
            amenities: record.amenities, checkInTime: checkInTime,
            checkOutTime: checkOutTime, mapLocations: record.mapLocations,
            contactInfo: record.contactInfo, houseRules: record.houseRules, cTA_Label: record.cTA_Label,
            cTA_Link: record.cTA_Link, accommodationTypeID: record.accommodationTypeID,
            galleryImageUrl: galleryImageFiles.length > 0 ? galleryImageFiles.map(x => x.url) : []
        }
        setOpen(true);
        eventEmitter.emit("clickableChange", true);
    };

    const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        getPropertyList(value);
        searchValue.current = value;
    };

    const showSliderModal = () => {
        setIsSliderModalOpen(true);
    };

    const handleSliderModalSave = () => {
        setIsSliderModalOpen(false);
    };

    const handleSliderModalCancel = () => {
        setIsSliderModalOpen(false);
        sliderForm.resetFields();
    };

    function getBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    };

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as File);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewVisible(true);
    };


    const handlePropertyMultipleChange = async ({ fileList }: { fileList: UploadFile[]; }) => {
        if (fileList.length > 0 && galleryImages.length !== fileList.length) {
            for (const x of fileList) {
                if (x.status === 'uploading' && x.originFileObj && !x.url) {
                    const fileExtension = x.originFileObj.name.split(".").pop();
                    const fileName = "property-place_" + new Date().getTime() + "." + fileExtension;
                    try {
                        const blobServiceClient = new BlobServiceClient(
                            `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                        );
                        const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);
                        const blobPath = "temp/" + fileName;
                        const blockBlobClient = containerClient.getBlockBlobClient(blobPath);

                        await blockBlobClient.uploadBrowserData(x.originFileObj, {
                            blobHTTPHeaders: { blobContentType: x.originFileObj.type }
                        });

                        const fileUrl = blockBlobClient.url;
                        x.url = fileUrl;

                        // Update gallery image list.
                        const imagesList: string[] = fileList.map(y => y.url ?? "");
                        const galleryImageFiles: UploadFile[] = imagesList.map((url, index) => ({
                            uid: `${index}`,
                            name: `Gallery Image ${index + 1}`,
                            status: 'done',
                            url: url,
                        }));
                        setPropertyGalleryImages(galleryImageFiles);
                    } catch (error: any) {
                        message.error("Error uploading file: " + error.message);
                        return false;
                    }
                }
            }
        }
    };

    const handleSingleChange = async ({ fileList }: { fileList: UploadFile[]; }) => {
        if (fileList.length > 0) {
            // Loop through each file in the list.
            for (const x of fileList) {
                if (x.status === 'uploading' && x.originFileObj && !x.url) {
                    // Generate a unique file name.
                    const fileExtension = x.originFileObj.name.split(".").pop();
                    const fileName = "property-place_" + new Date().getTime() + "." + fileExtension;
                    try {
                        // Initialize the BlobServiceClient using account name and SAS token.
                        const blobServiceClient = new BlobServiceClient(
                            `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                        );
                        // Get the container client.
                        const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);
                        // Define the blob path (using a "temp/" folder).
                        const blobPath = "temp/" + fileName;
                        const blockBlobClient = containerClient.getBlockBlobClient(blobPath);

                        // Upload the file using the browser data API.
                        await blockBlobClient.uploadBrowserData(x.originFileObj, {
                            blobHTTPHeaders: { blobContentType: x.originFileObj.type }
                        });

                        // Get the URL of the uploaded blob.
                        const fileUrl = blockBlobClient.url;
                        x.url = fileUrl;
                        const featuredImageFile: UploadFile = {
                            uid: '1',
                            name: 'Featured Image',
                            status: 'done',
                            url: fileUrl,
                        };

                        setFeaturedImage([featuredImageFile]);
                    } catch (error: any) {
                        message.error(error.message || 'Something went wrong. Please try again!');
                        return false;
                    }
                }
            }
        }
    };

    const onDeleteFeatureImageFile = async (file: UploadFile<any>) => {
        if (file && isNotNullUndefinedBlank(file.url)) {
            const fileName = file.url?.split('/').pop();
            if (isNotNullUndefinedBlank(fileName)) {
                try {
                    // Initialize the BlobServiceClient.
                    const blobServiceClient = new BlobServiceClient(
                        `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                    );
                    // Get the container client.
                    const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);

                    // Determine the blob path based on the file URL.
                    let blobPath = "";
                    if (file.url?.includes("/temp/")) {
                        blobPath = "temp/" + fileName;
                    } else {
                        // For single file uploads, if not in "temp", assume it is in "MostVisitedPlace/".
                        blobPath = "PropertyPlace/" + fileName;
                    }

                    const blockBlobClient = containerClient.getBlockBlobClient(blobPath);
                    await blockBlobClient.deleteIfExists();
                } catch (error: any) {
                    message.error("Error deleting file: " + error.message);
                    return false;
                }
                const images = featuredImage.filter(x => x.url !== file.url);
                setFeaturedImage(images);
            }
        }
    };

    const onDeletePropertyGalleryImagesFile = async (file: UploadFile<any>) => {
        if (file && isNotNullUndefinedBlank(file.url)) {
            const fileName = file.url?.split('/').pop();
            if (isNotNullUndefinedBlank(fileName)) {
                try {
                    const blobServiceClient = new BlobServiceClient(
                        `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                    );
                    const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);

                    let blobPath = "";
                    if (file.url?.includes("/temp/")) {
                        blobPath = "temp/" + fileName;
                    } else {
                        blobPath = "PropertyPlace/" + fileName;
                    }

                    const blockBlobClient = containerClient.getBlockBlobClient(blobPath);
                    await blockBlobClient.deleteIfExists();
                } catch (error: any) {
                    message.error("Error deleting file: " + error.message);
                    return false;
                }
                const images = propertyGalleryImages.filter(x => x.url !== file.url);
                setPropertyGalleryImages(images);
            }
        }
    };

    const getEmbedUrl = (input: string) => {
        if (input) {
            const match = input.match(/@(-?\d+\.\d+),(-?\d+\.\d+),(\d+)z/);
            if (match) {
                const [_, lat, lng, zoom] = match;
                return `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;
            }

            const coordMatch = input.match(/^(-?\d+\.\d+),\s*(-?\d+\.\d+)$/);
            if (coordMatch) {
                const [_, lat, lng] = coordMatch;
                return `https://www.google.com/maps?q=${lat},${lng}&z=17&output=embed`;
            }
        }
        return "";
    };

    const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const url = e.target.value;
        const embedUrl = getEmbedUrl(url);
        setMapUrl(embedUrl);
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div className="ant-upload-text">Upload</div>
        </div>
    );

    const fetchCities = (value: any) => {
        setCities([]);
        getCitiesList("", value, "", "", "", "");
    }

    const onCheckInTimeChange = (time: Dayjs) => {
        setCheckInValue(time);
        form.setFieldsValue({ checkInTime: time });
    };

    const onCheckOutTimeChange = (time: Dayjs) => {
        setcheckOutValue(time);
        form.setFieldsValue({ checkOutTime: time });
    };

    const handlePropertyStatusChange = (isActive: boolean, propertyPlaceId: string) => {
        setIsLoading(true);
        updateStatusProperty.mutate({
            propertyPlaceId: propertyPlaceId,
            isActive: isActive
        });
    }

    const handleSliderStatusChange = (isActive: boolean, sliderID: string) => {
        setIsSliderLoading(true);
        updateStatusSlider.mutate({
            sliderID: sliderID,
            isActive: isActive
        });
    }

    const handlePropertyChange = (selectedValues: string[]) => {
        setPropertyIds(selectedValues);
        const matchedImages = property
            .filter((x: any) => selectedValues.includes(x.propertyPlaceID))
            .map((x: any, index: number) => ({
                uid: `-${index + 1}`,
                name: `image${index + 1}.jpg`,
                url: x.featuredImageUrl,
            }));
        setGalleryImages(matchedImages);
    };


    const handlePreviewCancel = () => setPreviewVisible(false);

    return (
        <div>
            <div>
                <div className="flex justify-between align-middle pb-5">
                    <h2 className="text-2xl font-semibold text-black">{slider[0]?.title}</h2>
                    <div className="flex justify-between gap-5">
                        {slider[0]?.galleryImageUrl?.trim().length > 0 ? (
                            <Switch
                                size="default"
                                className="mt-3"
                                checked={slider[0]?.isActive || false}
                                loading={isSliderLoading}
                                onChange={(checked) =>
                                    handleSliderStatusChange(checked, slider[0]?.sliderID)
                                }
                            />
                        ) : null}
                        {slider.length > 0 ? (
                            HotelandairbnbEdit && (
                                <Button
                                    className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out"
                                    onClick={() => onEditSliderClick(slider[0])}
                                    icon={<EditOutlined />}
                                >
                                    Edit Slider
                                </Button>
                            )
                        ) : (
                            HotelandairbnbCreate && (
                                <Button
                                    className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out"
                                    onClick={showSliderModal}
                                    icon={<PlusOutlined />}
                                >
                                    Add Slider
                                </Button>
                            )
                        )}

                    </div>
                </div>

                <Card className="m-2 min-h-[100px]">
                    {isSliderLoading ? (
                        <div className="flex justify-center py-10">
                            <Spin />
                        </div>
                    ) : !slider || slider.length === 0 ? (
                        <div className="ant-empty text-center py-10">
                            <div className="ant-empty-image">
                                <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                                        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                                        <g fillRule="nonzero" stroke="#d9d9d9">
                                            <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                            <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div className="ant-empty-description">No data</div>
                        </div>
                    ) : (
                        <div className="flex gap-3">
                            {slider.map((slide, i) => {
                                const gallery = slide.galleryImageUrl ? JSON.parse(slide.galleryImageUrl) : [];

                                return gallery.map((img: any, idx: number) => (
                                    <Image
                                        key={`${i}-${idx}`}
                                        width={130}
                                        height={130}
                                        src={img.FeaturedImageUrl}
                                        alt={img.PropertyTitle}
                                        className="rounded-md object-cover"
                                    />
                                ));
                            })}
                        </div>
                    )}
                </Card>

                <Modal
                    title={isSliderEdited.current ? "Edit Slider" : "Add Slider"}
                    closable={{ 'aria-label': 'Custom Close Button' }}
                    open={isSliderModalOpen}
                    onOk={handleSliderModalSave}
                    onCancel={handleSliderModalCancel}
                    footer={null}
                >
                    <Form layout="vertical" form={sliderForm} onFinish={onSliderFinish}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="sliderID"
                                    label="Slider ID"
                                    style={{ display: 'none' }}
                                >
                                    <Input type="hidden" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="title"
                                    label="Title"
                                    rules={[{ required: true, message: 'Please enter your title' }]}
                                >
                                    <Input size="middle" placeholder="Please enter your title" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="propertyPlaceID"
                                    label="Property"
                                    rules={[{ required: true, message: "Please Select Property" }]}
                                >
                                    <Select
                                        mode="multiple"
                                        placeholder="Please select Property"
                                        optionFilterProp="label"
                                        allowClear
                                        options={property ? property.map((x: any) => ({ label: x.propertyTitle, value: x.propertyPlaceID })) : []}
                                        onChange={(selectedValues: string[]) => handlePropertyChange(selectedValues)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="galleryImageUrl" label="Selected Property's featured image">
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        <ImagePreviewGroup images={galleryImages} />
                                    </div>
                                </Form.Item>

                            </Col>
                        </Row>
                        <Space className="w-full justify-end">
                            <Button onClick={onClose} className="hover:!text-black hover:!border-black">Cancel</Button>
                            <Button htmlType="submit" className="bg-black text-white hover:bg-transparent hover:!text-black hover:!border-black">
                                {isSliderEdited.current ? "Update" : "Add"}
                            </Button>
                        </Space>
                    </Form>
                </Modal>
                <Modal
                    title={<span className="custom-modal-title">{getSliderModalTitle()}</span>}
                    open={isConfirmSliderModalVisible}
                    onOk={handleSliderSave}
                    onCancel={handleConfirmSliderModalCancel}
                    closeIcon={<CloseOutlined className="text-gray-500 hover:text-black" />}
                    footer={[
                        <Button key="back" onClick={handleConfirmSliderModalCancel} className="hover:!text-black hover:!border-black">
                            Cancel
                        </Button>,
                        <Button key="submit" onClick={handleSliderSave} className="bg-black text-white hover:bg-transparent hover:!text-black hover:!border-black">
                            Confirm
                        </Button>,
                    ]}
                >
                    {getSliderModelContent()}
                </Modal>
                <Modal open={previewVisible} footer={null} onCancel={handlePreviewCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
            <div>
                <div className="flex justify-between align-middle pb-5">
                    <h2 className="text-2xl font-semibold text-black">Airbnb and Hotel Listing</h2>
                    <div className="flex justify-between gap-5">
                        <div className="w-80 max-w-80">
                            <Search
                                placeholder="Search Property"
                                size="large"
                                enterButton
                                className="search-field"
                                onChange={onSearchChange}
                            />
                        </div>
                        {HotelandairbnbCreate && (
                            <Button className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out" onClick={showDrawer} icon={<PlusOutlined />}>
                                Add Property
                            </Button>)}
                    </div>
                </div>
                <Drawer
                    title={isPropertyEdited.current ? "Edit Property" : "Add New Property"}
                    width={370}
                    onClose={onClose}
                    open={open}
                    mask={false}
                    loading={isLoading}
                >
                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="propertyPlaceID"
                                    label="Property Place ID"
                                    style={{ display: 'none' }}
                                >
                                    <Input type="hidden" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="featuredImageUrl" label={getLabel("Upload Featured Image", false)}>
                                    <Upload
                                        listType="picture-card"
                                        fileList={featuredImage}
                                        onPreview={handlePreview}
                                        onChange={handleSingleChange}
                                        onRemove={e => onDeleteFeatureImageFile(e)}
                                    >
                                        {featuredImage.length >= 1 ? null : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="galleryImageUrl" label={getLabel("Upload Gallery Images", false)}>
                                    <Upload
                                        listType="picture-card"
                                        fileList={propertyGalleryImages}
                                        onPreview={handlePreview}
                                        onChange={handlePropertyMultipleChange}
                                        onRemove={e => onDeletePropertyGalleryImagesFile(e)}
                                    >
                                        {propertyGalleryImages.length >= 8 ? null : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Col span={24}>
                            <Form.Item
                                name="accommodationTypeID"
                                label="Accommodation Types"
                                rules={[{ required: true, message: "Please Select Accommodation Type" }]}
                            >
                                <Select
                                    className="h-12"
                                    placeholder="Please select Accommodation Type"
                                    optionFilterProp="label"
                                    options={accommodationTypes ? accommodationTypes.map((x: any) => ({ label: x.accommodationTypeName, value: x.accommodationTypeID })) : []}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="propertyTitle"
                                    label="Property Title "
                                    rules={[{ required: true, message: 'Please enter your property title' }]}
                                >
                                    <Input size="large" placeholder="Please enter your property title" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Col span={24}>
                            <Form.Item
                                name="countryID"
                                label="Country Name"
                                rules={[{ required: true, message: "Please Select Country Name" }]}
                            >
                                <Select
                                    className="h-12"
                                    placeholder="Please select Country Name"
                                    optionFilterProp="label"
                                    options={country ? country.map((x: any) => ({ label: x.countryName, value: x.countryId })) : []}
                                    onChange={(value) => { fetchCities(value) }}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="cityID"
                                label="City Name"
                                rules={[{ required: true, message: "Please Select City Name" }]}
                            >
                                <Select
                                    className="h-12"
                                    placeholder="Please select City Name"
                                    optionFilterProp="label"
                                    options={cities ? cities.map((x: any) => ({ label: x.cityName, value: x.cityId })) : []}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="description"
                                    label="Description"
                                    rules={[{ required: true, message: 'Please enter your description' }]}
                                >
                                    <ReactQuill
                                        theme="snow"
                                        value={placeDescription}
                                        onChange={value => setPlaceDescription(value)}
                                        placeholder="Please enter property description"
                                        modules={modules}
                                        formats={formats}
                                        className="custom-quill"
                                        ref={editor_ref}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="bedrooms"
                                    label="Bedrooms"
                                    rules={[{ required: true, message: 'Please enter number of bedrooms' }]}
                                >
                                    <Input size="large" placeholder="Number of Bedrooms" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="beds"
                                    label="Beds"
                                    rules={[{ required: true, message: 'Please enter number of beds' }]}
                                >
                                    <Input size="large" placeholder="Number of beds" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="bathrooms"
                                    label="Bathrooms"
                                    rules={[{ required: true, message: 'Please enter number of bathrooms' }]}
                                >
                                    <Input size="large" placeholder="Number of Bathrooms" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="guestCapacity"
                                    label="GuestCapacity"
                                    rules={[{ required: true, message: 'Please enter number of guestCapacity' }]}
                                >
                                    <Input size="large" placeholder="Number of Guests" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="amenities"
                                    label="Amenities (comma separated)"
                                    rules={[
                                        { required: true, message: 'Please enter your amenities' },
                                        {
                                            pattern: /^([A-Za-z\s]+)(,\s*[A-Za-z\s]+)*$/,
                                            message: 'Only words separated by commas are allowed (e.g., WiFi, Pool, Kitchen)',
                                        },
                                    ]}
                                >
                                    <Input size="large" placeholder="e.g., WiFi, Pool, Kitchen, AC" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="checkInTime"
                                    label="Check-in Time"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your Check-in Time",
                                        },
                                    ]}
                                >
                                    <TimePicker
                                        value={checkInValue}
                                        use12Hours
                                        format="hh:mm:ss A"
                                        onChange={onCheckInTimeChange}
                                        style={{ width: "315px", height: "40px" }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="checkOutTime"
                                    label="Check-out Time"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your Check-out Time",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const checkIn = getFieldValue("checkInTime");
                                                if (!value || !checkIn) {
                                                    return Promise.resolve();
                                                }
                                                if (value.isSame(checkIn)) {
                                                    return Promise.reject(
                                                        new Error(
                                                            "Check-out time cannot be the same as Check-in time"
                                                        )
                                                    );
                                                }
                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                >
                                    <TimePicker
                                        value={checkOutValue}
                                        use12Hours
                                        format="hh:mm:ss A"
                                        onChange={onCheckOutTimeChange}
                                        style={{ width: "315px", height: "40px" }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="mapLocations"
                                    label="Map Location (address or link)"
                                >
                                    <Input size="large" placeholder="Paste Google Maps address or coordinates" onChange={handleLocationChange} />
                                </Form.Item>
                            </Col>
                        </Row>
                        {mapUrl && (
                            <iframe
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                loading="lazy"
                                allowFullScreen
                                referrerPolicy="no-referrer-when-downgrade"
                                src={mapUrl}
                            ></iframe>
                        )}
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="contactInfo"
                                    label="Contact Info"
                                    rules={[
                                        {
                                            required: true,
                                            validator(_, value) {
                                                if (!value) {
                                                    return Promise.reject(new Error('Please enter your contact info'));
                                                }

                                                const phoneRegex = /^\d{7,12}$/;
                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                if (phoneRegex.test(value) || emailRegex.test(value)) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(new Error('Enter a valid phone number (7-12 digits) or a valid email address.'));
                                            },
                                        },
                                    ]}
                                >
                                    <Input size="large" placeholder="Phone number, email, etc." />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="houseRules"
                                    label="House Rules / Policies"
                                >
                                    <Input size="large" placeholder="List any important rules or policies" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="cTA_Label"
                                    label="CTA Button Text"
                                    rules={[{ required: true, message: 'Please enter your Label' }]}
                                >
                                    <Input size="large" placeholder="e.g., Book Now, View Listing" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="cTA_Link"
                                    label="CTA Button URL"
                                    rules={[{ required: true, message: 'Please enter your URL' },
                                    { type: 'url', message: 'Please enter a valid URL (e.g. https://example.com)' }]}
                                >
                                    <Input size="large" placeholder="Paste Airbnb or hotel booking URL" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Space className="w-full justify-end">
                            <Button onClick={onClose} className="hover:!text-black hover:!border-black">Cancel</Button>
                            <Button htmlType="submit" className="bg-black text-white hover:bg-transparent hover:!text-black hover:!border-black">
                                {isPropertyEdited.current ? "Update" : "Add"}
                            </Button>
                        </Space>
                    </Form>
                </Drawer>
                {isLoading ? (
                    <div className="flex justify-center py-10">
                        <Spin />
                    </div>
                ) : property.length === 0 ? (
                    <div className="ant-empty text-center py-10">
                        <div className="ant-empty-image">
                            <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                                <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                                    <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                                    <g fillRule="nonzero" stroke="#d9d9d9">
                                        <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                        <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div className="ant-empty-description">No data</div>
                    </div>
                ) : (
                    property.map((pro) => (
                        <Card key={pro.propertyPlaceID} className="m-1">
                            <div className="flex items-start gap-4">
                                <Image
                                    width={130}
                                    height={130}
                                    src={pro.featuredImageUrl}
                                    alt="Property"
                                    className="rounded-md object-cover"
                                />
                                <div className="flex-1">
                                    <div className="mb-1">
                                        <h3 className="text-lg font-semibold">{pro.propertyTitle}</h3>
                                        <p className="text-sm text-gray-500">{pro.cityName}</p>
                                        <p className="text-sm text-gray-500">
                                            {pro.beds} Beds, {pro.bathrooms} Bathrooms, Sleeps {pro.guestCapacity}
                                        </p>
                                    </div>

                                    <div className="flex items-center gap-2 mb-1">
                                        {HotelandairbnbEdit && (
                                            <button className="px-2 py-1 text-white bg-blue-600 rounded hover:bg-blue-500 text-sm" onClick={() => onEditPropertyClick(pro)}>
                                                Edit
                                            </button>)}
                                        {HotelandairbnbDelete && (
                                            <button className="px-2 py-1 text-white bg-red-600 rounded hover:bg-red-500 text-sm" onClick={() => onDeleteProperty(pro)}>
                                                Delete
                                            </button>)}
                                        <button className="px-2 py-1 text-white bg-green-600 rounded hover:bg-green-500 text-sm" onClick={() => handleViewProperty(pro)}>
                                            View
                                        </button>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <Switch size="small" checked={pro.isActive} loading={isLoading} onChange={(checked) => handlePropertyStatusChange(checked, pro.propertyPlaceID)} />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))
                )}

                <Modal
                    title={<span className="custom-modal-title">{getPropertyViewModalTitle()}</span>}
                    open={isViewPropertyModalVisible}
                    onCancel={handleViewPropertyModalCancel}
                    closeIcon={<CloseOutlined className="text-gray-500 hover:text-black" />}
                    footer={[]}
                >
                    {getViewPropertyModelContent()}
                </Modal>

                <Modal
                    title={<span className="custom-modal-title">{getModalTitle()}</span>}
                    open={isConfirmPropertyModalVisible}
                    onOk={handlePropertySave}
                    onCancel={handlePropertyModalCancel}
                    closeIcon={<CloseOutlined className="text-gray-500 hover:text-black" />}
                    footer={[
                        <Button key="back" onClick={handlePropertyModalCancel} className="hover:!text-black hover:!border-black">
                            Cancel
                        </Button>,
                        <Button key="submit" onClick={handlePropertySave} className="bg-black text-white hover:bg-transparent hover:!text-black hover:!border-black">
                            Confirm
                        </Button>,
                    ]}
                >
                    {getPropertyModelContent()}
                </Modal>
            </div>
        </div>
    );
}
export default HotelAndAirbnb;
